import React, { Component, Fragment } from 'react';
import { services } from '@comall-backend-builder/core';
import { Button as AntButton, Table, Input, Tag, Spin, message as AntMessage } from 'antd';
import { errorHandle } from '../../services/error-handle';
import { PrintModal } from './components/PrintModal';
import { cloneDeep } from 'lodash';

interface ChangePriceSelectorStates {
    columns: object[];
    tableData: object[];
    orderId: string;
    loading: boolean;
    spinning: boolean;
    listVisible: boolean;
    printData: object[];
}

export class OrderPrint extends Component<ChangePriceSelectorStates> {
    constructor(props) {
        super(props);
        this.loadProductList = this.loadProductList.bind(this);
        this.saveSknChangePrice = this.saveSknChangePrice.bind(this);
    }
    state = {
        spinning: false,
        orderId: '',
        columns: [
            {
                title: '商品编码',
                dataIndex: 'sknCode',
                key: 'sknCode',
            },
            {
                title: '商品名称',
                dataIndex: 'skuName',
                key: 'skuName',
            },
            {
                title: '单位',
                dataIndex: 'unit',
                key: 'unit',
            },
            {
                title: '数量',
                dataIndex: 'qty',
                key: 'qty',
            },
            {
                title: '零售单价',
                dataIndex: 'price',
                key: 'price',
            },
            {
                title: '金额',
                dataIndex: 'excutePrice',
                key: 'excutePrice',
            },
            {
                title: '实销金额',
                dataIndex: 'afterFoldingPrice',
                key: 'afterFoldingPrice',
            },
        ],
        tableData: [],
        loading: false,
        listVisible: false,
        printData: [],
    };
    showModal() {
        let { listVisible, tableData, orderId } = this.state;
        if (!orderId) {
            AntMessage.info('请先输入销售单号！');
            return;
        }
        if (tableData.length === 0) {
            AntMessage.info('无商品可打印！');
            return;
        }
        this.setState({
            listVisible: !listVisible,
        });
    }
    loadProductList() {
        let { orderId } = this.state;
        if (!orderId) {
            AntMessage.info('请先输入销售单号！');
            return;
        }
        this.setState({
            loading: true,
        });
        services.api
            .get({}, { apiPath: `/8001/order/getPrintInfo?orderNo=${orderId}` })
            .then((res: any) => {
                const result = res;
                // const result = {
                //     "shopName":"MM09门店",
                //     "billDate":"2022-01-11 14:11:37",
                //     "orderNo":"PZ22011114115985",
                //     "vipNo":"P210415001",
                //     "vipName":"啦啦",
                //     "sknList":[
                //         {
                //             "sknCode":"P275662418",
                //             "skuName":"爱马仕丝巾",
                //             "unit":"件",
                //             "qty":1,
                //             "price":1600,
                //             "excutePrice":1552,
                //             "afterFoldingPrice":1086.4,
                //             "remark":null,
                //             "keyValueList":[

                //             ]
                //         },
                //         {
                //             "sknCode":"P275662418",
                //             "skuName":"爱马仕丝巾",
                //             "unit":"件",
                //             "qty":1,
                //             "price":1600,
                //             "excutePrice":1552,
                //             "afterFoldingPrice":1086.4,
                //             "remark":null,
                //             "keyValueList":[

                //             ]
                //         },
                //         {
                //             "sknCode":"P275662418",
                //             "skuName":"爱马仕丝巾",
                //             "unit":"件",
                //             "qty":1,
                //             "price":1600,
                //             "excutePrice":1552,
                //             "afterFoldingPrice":1086.4,
                //             "remark":null,
                //             "keyValueList":[

                //             ]
                //         },
                //     ],
                //     "payList":[
                //         {
                //             "payTypeName":"电商微信H5",
                //             "paidAmount":1086.4
                //         },
                //         {
                //             "payTypeName":"电商微信H5",
                //             "paidAmount":1086.4
                //         },
                //         {
                //             "payTypeName":"电商微信H5",
                //             "paidAmount":1086.4
                //         },
                //         {
                //             "payTypeName":"电商微信H5",
                //             "paidAmount":1086.4
                //         },
                //     ],
                //     "totalQty":1,
                //     "realTotalPriceStr":"壹仟零捌拾陆圆肆角",
                //     "realTotalPrice":1086.4,
                //     "payTime":"2022-01-11 14:24:21"
                // }
                // 先计算总页数（1页=2行商品 或 1页=1行商品+3行支付信息 或 1页=0行商品+9行支付），
                if (result && result.sknList && result.sknList.length) {
                    // 先计算总页数
                    let total = 0;
                    let sknProductPage = parseInt((result.sknList.length / 2).toString());
                    total += sknProductPage;
                    console.log(total, sknProductPage);
                    let num = result.sknList.length % 2; // 商品2个为一组，有余数的话，说明需要组装一个既有商品又有支付信息的一条数据
                    if (num === 1) {
                        if (result.payList && result.payList.length) {
                            if (result.payList.length <= 3) {
                                total += 1;
                            } else {
                                total += 1 + Math.ceil((result.payList.length - 3) / 9);
                            }
                        } else {
                            total += 1;
                        }
                    } else {
                        // 没有余数得话，说明剩余得全是支付信息
                        if (result.payList && result.payList.length) {
                            total += Math.ceil(result.payList.length / 9);
                        } else {
                            total += 1;
                        }
                    }

                    // 再将商品2个为一组塞进每项的sknList，不足2个商品的 1个商品塞进sknList， <=3个支付塞进payList
                    let outputList = [];
                    let cloneSknList = cloneDeep(result.sknList);
                    let upArraySknList = this.getnewList(cloneSknList, 2);
                    upArraySknList.forEach((item, index) => {
                        let itemObj: any = {};
                        if (item.length === 1) {
                            if (result.payList && result.payList.length) {
                                if (result.payList.length <= 3) {
                                    itemObj.payList = result.payList;
                                } else {
                                    itemObj.payList = result.payList.slice(0, 3);
                                }
                            }
                            itemObj.sknList = item; // 商品列表
                            itemObj.currentPageQty = item[0].qty; // 当前页小计数量
                            itemObj.currentPageAmount = item[0].afterFoldingPrice; // 当前页小计金额
                        } else {
                            itemObj.payList = [];
                            itemObj.sknList = item; // 商品列表
                            itemObj.currentPageQty = item[0].qty + item[1].qty; // 当前页小计数量
                            itemObj.currentPageAmount =
                                item[0].afterFoldingPrice + item[1].afterFoldingPrice; // 当前页小计金额
                        }
                        outputList.push(itemObj);
                    });
                    // 如果以商品为维度组装后的outputList长度还小于总页数，说明剩余的几页都是放着支付信息
                    // 取剩余的支付信息,9个为一组塞进payList
                    if (outputList.length < total) {
                        let clonepayList;
                        if (num === 1) {
                            clonepayList = cloneDeep(result.payList.slice(3));
                        } else {
                            clonepayList = cloneDeep(result.payList);
                        }
                        let upArrayPayList = this.getnewList(clonepayList, 9);
                        upArrayPayList.forEach((payItem) => {
                            let payItemObj: any = {};
                            payItemObj.payList = payItem;
                            payItemObj.sknList = []; // 商品列表
                            payItemObj.currentPageQty = 0; // 当前页小计数量
                            payItemObj.currentPageAmount = 0; // 当前页小计金额
                            outputList.push(payItemObj);
                        });
                    }
                    // 将公共的数据塞进去
                    outputList.forEach((outputItem) => {
                        outputItem.shopName = result.shopName; // 门店名称
                        outputItem.billDate = result.billDate; // 单据日期
                        outputItem.orderNo = result.orderNo; // 单据编号
                        outputItem.vipNo = result.vipNo;
                        outputItem.vipName = result.vipName;
                        outputItem.totalPage = total;
                        outputItem.totalQty = result.totalQty;
                        outputItem.realTotalPriceStr = result.realTotalPriceStr;
                        outputItem.realTotalPrice = result.realTotalPrice;
                        outputItem.payTime = result.payTime;
                    });
                    console.log(outputList);
                    this.setState({
                        printData: outputList,
                        tableData: result.sknList,
                    });
                }
                this.setState({
                    loading: false,
                });
            })
            .catch((e: any) => {
                errorHandle(e);
            });
    }
    // 将一维数组按照每项有num个子项，变为二维数组
    getnewList(list, num) {
        let newList = [];
        let len = list.length;
        let n = num;
        let lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
        for (let i = 0; i < lineNum; i++) {
            let temp = list.slice(i * n, i * n + n);
            newList.push(cloneDeep(temp));
        }
        return newList;
    }
    saveSknChangePrice() {}

    render() {
        const { spinning, listVisible, tableData, printData, loading, columns } = this.state;
        return (
            <Fragment>
                <Spin spinning={spinning}>
                    <span>选择销售订单：</span>
                    <Input
                        style={{ width: 300, marginBottom: '10px' }}
                        placeholder="请输入销售订单"
                        onChange={(v) => {
                            this.setState({
                                orderId: v.target.value,
                            });
                        }}
                    />
                    <AntButton
                        style={{ marginLeft: 16 }}
                        type="primary"
                        onClick={this.loadProductList}
                    >
                        查询
                    </AntButton>
                    <AntButton
                        style={{ marginLeft: 16 }}
                        type="primary"
                        onClick={this.showModal.bind(this)}
                    >
                        打印预览
                    </AntButton>
                    <Table
                        rowKey="sknCode"
                        loading={loading}
                        pagination={false}
                        columns={columns}
                        dataSource={tableData}
                    />
                </Spin>
                {listVisible && (
                    <PrintModal
                        printData={printData}
                        visible={listVisible}
                        onCancel={() => {
                            this.setState({
                                listVisible: false,
                            });
                        }}
                    />
                )}
            </Fragment>
        );
    }
}
